export class RestaurantInfo {
	addressLine1: string;
	addressLine2: string;
	addressLine3: string;
	currencyName: string;
	name: string;
	serviceChargePercentage: number;
	telephone: string;
	zipCode: string;
	defaultTaxRate: number;
	multiLanguage: boolean;
	defaultLanguage: string;
}
